import React from 'react';
import { list1, list2, list3, list4, list5, list6, list7 } from './data';
import './Styles/Container.scss';

const Container=()=>{
    return(
        <div className="prototype-container">
            <div className="prototype">
        <div>
            <List list={list1}
            title="Getting started"
             />
            <List list={list2} 
            title="Creating prototypes"
            />
              <List list={list3} 
            title="Organising designs with sections"
            />
            <List 
            title="Prototyping settings"
            list={list4}
            />
        </div>
        <div>
            <List list={list5}
            title="Advanced prototyping"
             />
            <List list={list6} 
            title="Sharing"
            />
              <List list={list7} 
            title="Stories proper"
            />
        
        </div>
        </div>
        </div>
    )
};
export default Container ;

export function List(props){
    return(
        <div className="prototypelist">
            {props.title ? <h2>{props.title}</h2> : null}
            <ul>
                {props.list.map((item) =>{
                    return(
                        <li>{item}</li>
                    )
                })}
            </ul>
        </div>
    )
};